module.exports = __webpack_public_path__ + "static/img/bridges05.979232b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/blog/bridges05.jpg
// module id = e6L5
// module chunks = 0